import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Methods } from '@/api/v1/cart'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

export type UpdateCartItemDTO = {
  data: Methods['patch']['reqBody']
}

type MutationResponse = Awaited<ReturnType<typeof aspidaClient.v1.cart.$patch>>

type UseUpdateCartItemOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, UpdateCartItemDTO>,
    'mutationFn'
  >
}

export const useUpdateCartItem = ({ config }: UseUpdateCartItemOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = ({ data }: UpdateCartItemDTO) => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.$patch({ body: data })
    }
    return aspidaClient.v1.cart.$patch({ body: data })
  }

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.itemCount()),
    ...config,
  } as UseMutationOptions<MutationResponse, AxiosError, UpdateCartItemDTO>)
}
